var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container__progress-line",class:_vm.direction},[_c('simple-svg',{attrs:{"src":require("@/assets/progressIcon.svg"),"width":"9px","height":"12px"}}),_c('div',{staticClass:"line"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }